import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useShangpinListQuery } from '../../store/dianshangtaizhangApi';

function GoodsSelect(props) {
    const [list,setList] = useState();
    const {data,isSuccess} =useShangpinListQuery()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                
                const newArr = data.Result.map((item) => {
                    const {sp_id,sp_name }=item;
                    return item = {value:sp_id,label:sp_name }
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
                style={props.formStyle}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        console.log(f);
                        props.onChange(f.value,f.label,)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.placeholder}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default GoodsSelect